export enum FeatureOverideTier {
  // needs to add what API accepts
  InternalPremium = 'InternalPremium',
  ManagedPremium = 'ManagedPremium',
  SelfServeStandard = 'SelfServeStandard',
  Api = 'Api',
  SelfServeExperiment = 'SelfServeExperiment',
  SelfServeSearch = 'SelfServeSearch'
}
